import { useCallback } from "react";
import { useNavigate } from 'react-router';
import { routes } from "const/routes";

export function useLogout() {
  const navigate = useNavigate();
    return useCallback(() => navigate(routes.logout), [navigate]);
}